export const wait = (ms = 1000) => new Promise((res) => setTimeout(res, ms));
